import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import StoreBrands$1 from './StoreBrands.js';

const StoreBrandContainer = ({ brands  })=>{
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            title: getLabel('stores.page.details.brands.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreBrands$1, {
        labels: labels,
        brands: brands
    });
};
var StoreBrands = StoreBrandContainer;

export { StoreBrands as default };
//# sourceMappingURL=StoreBrandsContainer.js.map
